import { useNavBarStore } from "../store";
import { Navigation } from "./navigation";
import { AccountSelector } from "./accountSelector";
import { Box, Typography } from "@dealer-center/core-components";

export const Left = () => {
  const { visibility } = useNavBarStore();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
      }}
    >
      {!visibility.pinLinksMenu && <Navigation />}
      {visibility.shouldShowDealerCenterText && (
        <Typography
          sx={{
            color: "white",
            fontWeight: "normal"
          }}
          variant="h3"
        >
          Dealer Center
        </Typography>
      )}
      {!visibility.shouldShowAccountSelectorInCenter && (
        <AccountSelector iconOnly={visibility.shouldAccountSelectorBeAnIcon} />
      )}
    </Box>
  );
};
